module.exports = __webpack_public_path__ + "static/media/titaneyeplus1.516620d7.jpeg";